<template>
  <s-button :danger="danger" :icon="getIcon" @click="checkTfaStatusAndProceed">
    <slot></slot>
  </s-button>
</template>

<script>
import { AUTH_GETTERS } from '@/store/modules/auth';
import { CURRENT_USER_ACTIONS } from '@/store/modules/currentuser';
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    icon: {
      type: String,
      required: false,
      default: null
    },
    callback: {
      type: Function,
      required: true
    },
    danger: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    ...mapActions('currentuser', {
      $open2fa: CURRENT_USER_ACTIONS.TRIGGER_2FA_MODAL
    }),
    checkTfaStatusAndProceed() {
      if (!this.$2faEnabled) {
        this.$open2fa(3);
      } else {
        this.callback();
      }
    }
  },
  computed: {
    ...mapGetters('auth', {
      $2faEnabled: AUTH_GETTERS.TFA_ENABLED
    }),
    getIcon() {
      return this.$2faEnabled ? this.icon : 'mdi-shield-outline';
    }
  }
};
</script>

<style></style>
